import ky from 'ky';

class APIWrapper {
  constructor() {
    // because of the proxy
    this._baseURL = '/api';
  }

  _req = async endpoint => ky(`${this._baseURL}/${endpoint}`).json();

  getRooms = async () => this._req('rooms');

  getRoom = async id => this._req(`rooms/${id}`);

  getClients = async () => this._req('clients');

  getClient = async id => this._req(`clients/${id}`);
}

const wrapper = new APIWrapper();
const initWrapper = () => {

};

export default wrapper;
export {
  wrapper,
  initWrapper,
};
